import TaskContainer from "../../Componant/Task";

const Task = () => {
  return (
    <div className="page-body">
      <TaskContainer />
    </div>
  );
};

export default Task;
